import React, { useEffect, useState } from "react";
import BackToTop from "../../components/elements/BackToTop";
import Header from "../../components/Layout/Header";
import navImg1 from "../../assets/images/resources/logo-1.png";
import Footer from "../../components/Layout/Footer";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import CtaTwo from "../../components/Common/CtaSection/CtaTwo";
import EventSingleMain from "./EventSingleMain";
const bannerbg = "https://loremflickr.com/1920/495/event,crowd?lock=132";

const EventSingle = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    setIsVisible(scrollTop > 300);
  };

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);
    return () => document.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <React.Fragment>
      <Header navImg={navImg1} parentMenu="events" activeMenu="/events" />
      <SiteBreadcrumb pageTitle="Event Details" pageName="Event Details" breadcrumbsImg={bannerbg} />
      <EventSingleMain />
      <CtaTwo />
      <BackToTop scroll={isVisible} />
      <Footer />
    </React.Fragment>
  );
};

export default EventSingle;
